export const NAMES = {
  SET_FIELD_DATA: 'SET_FIELD_DATA',
  SET_SUCCESS: 'SET_SUCCESS'
}

export const setFormData = payload => ({ type: NAMES.SET_FIELD_DATA, payload })
export const setSuccess = payload => ({ type: NAMES.SET_SUCCESS, payload })
